import { Profile } from "../../account/type/profile";

export class ProfileAdapter {
  static toInputDTO(req: any): any {
    return {
      project_name: req.project,
      vendor_name: req.organization,
      email: req.email,
      phone: req.phone,
      manager_department: req.department,
      manager_position: req.position,
      manager_name: req.owner,
      address: req.address,
      city: req.city,
      prefecture: req.prefecture,
      postcode: req.postcode,
      country: req.country,
      logo: req.logo,
    };
  }

  static toOutputDTO(res: any): Profile {
    return {
      project: {
        name: res.project_name,
      },
      profile: {
        name: res.vendor_name,
        email: res.email,
        phone: res.phone,
      },
      owner: {
        department: res.manager_department,
        position: res.manager_position,
        name: res.manager_name,
      },
      address: {
        address: res.address,
        city: res.city,
        prefecture: res.prefecture,
        postcode: res.postcode,
        country: res.country,
      },
      logo: { url: res.image_url },
    };
  }
}
